import { render, staticRenderFns } from "./profile-information.vue?vue&type=template&id=0dc7d47c&"
import script from "./profile-information.vue?vue&type=script&lang=ts&"
export * from "./profile-information.vue?vue&type=script&lang=ts&"
import style0 from "./profile-information.vue?vue&type=style&index=0&id=0dc7d47c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports